import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Controller, useForm } from 'react-hook-form';

import { Password } from "primereact/password";
import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoGethex from '../../../../assets/img/gethex-peru-nuevo.png';
import { useAuth } from "../../../../Shared/Context/AuthContext";
import { useToast } from "../../../../Shared/hook/useToast";
import { UserDataStorage } from "../../../../Shared/Storage/UserDataStorage";
import './Login.css';
import LoginViewModel from "./LoginViewModel";

export const Login = ()=> {

    // const [passView, setPassView] = useState<string>('password');
     const navigate = useNavigate();
     const { login } = useAuth();
     const [showSpinner, setShowSpinner] = useState(false);
     const [nameUser, setNameUser] = useState("");

    // const toast = useRef(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();

    const {
        loginUser,
        dataUser
      } = LoginViewModel();
        
    const defaultValues = {
        user: '', 
        pass: '', 
    };

//    const show = (severity: any, summary: any, detail: any) => {
//         // @ts-ignore
//         toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
//     };

    const onSubmit = async (
            data: { 
                user: string, 
                pass: string, 
            }
        ) => {

            try {
                const dataUserLogin = await loginUser(data.user, data.pass);
               
                
                const faJarWheat:any = dataUserLogin;

                const fullUsernames = UserDataStorage.get().userInfo.firtsName +" "+ UserDataStorage.get().userInfo.lastName;

               if (!dataUserLogin || !faJarWheat.jwToken) {
                showError("Error", "Usuario o contraseña incorrectos");
                reset();
                return;
                }
                login(dataUserLogin);

                // showSuccess("Bienvenido", fullUsernames);
                setNameUser(fullUsernames);
                setShowSpinner(true);
                setTimeout(() => {
                    window.location.href = "/";
                }, 3000);
                

            
        } catch (error) {
            console.error("Error en el login:", error);
            showError("Error", "Hubo un problema en la conexión con el servidor");
            reset();
        }
    };
    const {
        control,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };
    return (
        <>
            {
                showSpinner &&
                <div className="progressSpinner">
                    <p className="text-white">Bienvenido {nameUser}</p>
                    <ProgressSpinner />
                </div>
            }
            <div className="content">
                <form  onSubmit={handleSubmit(onSubmit)} className="contentForm">
                    <div className="content-user-total">
                        <div className="content-user-login">
                            <img className="img-fluid img-logo" src={LogoGethex} alt="logo" />
                        </div>
                    </div>
                    {/* <Toast ref={toast} /> */}
                    <Controller
                        name="user"
                        control={control}
                        rules={{ required: 'Usuario es requerido.' }}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name}>
                                    Usuario 
                                </label>
                                <InputText  id={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} placeholder="Ingresa tu usuario" validateOnly={true} pattern="[a-zA-Z0-9!#$%&'*\/=?^_`\{\|\}~\+\-]([\.]?[a-zA-Z0-9!#$%&'*\/=?^_`\{\|\}~\+\-])+@[a-zA-Z0-9]([^@&%$\/\(\)=?¿!\.,:;]|\d)+[a-zA-Z0-9][\.][a-zA-Z]{2,4}([\.][a-zA-Z]{2})?" />
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                        
                    />
                    <Controller
                        name="pass"
                        control={control}
                        rules={{ required: 'Clave es requerido.' }}
                        render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name}>
                                    Clave 
                                </label>
                                <Password id={field.name} {...field} inputRef={field.ref} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} toggleMask  placeholder="Ingresa tu clave"/>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                        
                    />
                    {/* <label>Usuario</label>
                    <input type="text" name="" placeholder="Ingresa tu usuario" /> */}
                    {/* <label>Clave</label>
                    <input type="password" name="" placeholder="Ingresa tu clave" /> */}
                    {/* <button type="submit" className="btn-submit">Iniciar</button> */}
                    <Button label="Ingresar" type="submit" icon="pi pi-check" className="btn btn-dark" />  
                    <div className="passContent">
                        <a href="/">¿Olvidaste tu contraseña?</a>
                    </div>
                    <div className="text-center text-light pt-3">
                        GOMAX PERÚ © 2019. Todos los derechos reservados.
                    </div>
                </form>  
            </div>
        </>
    );
}